import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomSnackbarComponent } from 'src/app/_shared/component/custom-snackbar/custom-snackbar.component';
import { CmaService } from '../cma.service';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-share-cma-report-dialogbox',
  templateUrl: './share-cma-report-dialogbox.component.html',
  styleUrls: ['./share-cma-report-dialogbox.component.scss'],
})
export class ShareCmaReportDialogboxComponent implements OnInit {
  shareReportForm: FormGroup;
  cmaReports: any;
  cmaReportIdFromUrl: any;
  @ViewChild('shareReportDialog') shareReportDialog!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;
  @Input() shareReportInput: any;
  isViewCmaPage: boolean = false;
  cmaViewPath: any;
  constructor(
    private fb: FormBuilder,
    public cmaService: CmaService,
    private snackbar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    public cma: CmaState,
    private dialog: MatDialog,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.shareReportForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      clientEmail: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.cmaReportIdFromUrl = params['id'] || null;
    });

    const currentUrl = this.router.url;
    if ((currentUrl.includes('/cma/view') && this.cmaReportIdFromUrl) || currentUrl.includes('/dashboard')) {
      this.isViewCmaPage = true;
    } else {
      this.isViewCmaPage = false;
    }
    this.cma.cmaReports.subscribe((reports) => {
      this.cmaReports = reports;
      this.setNamePartsToForm(this.cmaReports);
    });

    const currentFirstName = this.shareReportForm?.get('firstName')?.value;
    const currentLastName = this.shareReportForm?.get('lastName')?.value;

    if (this.shareReportInput && (!currentFirstName || !currentLastName)) {
      this.setNamePartsToForm(this.shareReportInput);
    }
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  shareCmaReport() {
    if (this.shareReportForm.valid) {
      if (this.cmaReportIdFromUrl || this.shareReportInput._id) {
        let params = {
          reportId: this.cmaReportIdFromUrl || this.shareReportInput._id || null,
          clientFirstName: this.shareReportForm.value.firstName,
          clientLastName: this.shareReportForm.value.lastName,
          clientEmail: this.shareReportForm.value.clientEmail,
        };

        this.cmaService.shareCmaReport(params).subscribe({
          next: (response) => {
            if (response.error) {
              console.error('Error fetching report:', response.error);
            } else {
              if (response && response.status == 'OK') {
                this.openSnackbar(response.message, true);
                this.shareReportForm.get('lastName')?.reset(null, { emitEvent: false });
                this.shareReportForm.get('clientEmail')?.reset(null, { emitEvent: false });
              }
            }
          },
          error: (err) => console.error('Unexpected error:', err),
          complete: () => console.log('Subscription completed.'),
        });
        this.closeDialog();
      }
    }
  }

  openShareDialog(): void {
    this.cma.cmaReports.subscribe((reports) => {
      this.cmaReports = reports;
      this.setNamePartsToForm(this.cmaReports);
    });
    const currentFirstName = this.shareReportForm?.get('firstName')?.value;
    const currentLastName = this.shareReportForm?.get('lastName')?.value;

    if (this.shareReportInput && (!currentFirstName || !currentLastName)) {
      this.setNamePartsToForm(this.shareReportInput);
    }
    this.dialogRef = this.dialog.open(this.shareReportDialog);
  }

  openSnackbar(upgradeMsg, success = false, persistent = false) {
    const snackbarRef = this.snackbar.openFromComponent(CustomSnackbarComponent, {
      data: { message: upgradeMsg },
      duration: persistent ? undefined : 5000,
      panelClass: [success ? 'snackbar-success' : 'snackbar-error'],
      verticalPosition: 'top',
    });
    snackbarRef.afterDismissed().subscribe(() => {});
  }

  private setNamePartsToForm(source: { clientName?: string } | null) {
    if (source?.clientName) {
      const nameParts = source.clientName.split(' ');
      this.shareReportForm?.patchValue({
        firstName: nameParts[0] || '',
        lastName: nameParts[1] || '',
      });
    }
  }
}
